import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Text from 'crehana-ui/Text';

import { randomizer } from 'Utils';

const BASE_URL =
  typeof window !== 'undefined' ? `${window.location.origin}/` : '';

class SEO extends Component {
  state = {
    error: null,
  };

  componentDidCatch() {
    this.setState({
      error: true,
    });
  }

  getOnClick = (bc, last) => {
    if (!last) {
      if (bc.onClick) {
        return bc.onClick;
      }
      return () => window.location.assign(`${BASE_URL}${bc.url}`);
    }
    return undefined;
  };

  render() {
    const { breadcrumbs, title, hidden, white, ...other } = this.props;
    const { error } = this.state;

    if (error) {
      return null;
    }

    /**
     * A breadcrumb trail on a page indicates the page's position in the site hierarchy.
     * Google Search uses breadcrumb markup to categorize the information
     * from the page in search results.
     */
    const beadcrumbList = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': BASE_URL,
            name: 'Inicio',
          },
        },
      ],
    };

    for (let i = 0; i < breadcrumbs.length; i += 1) {
      beadcrumbList.itemListElement.push({
        '@type': 'ListItem',
        position: i + 2,
        item: {
          '@id': `${BASE_URL}${breadcrumbs[i].url}`,
          name: breadcrumbs[i].name,
          image: breadcrumbs[i].image,
        },
      });
    }

    return (
      <div {...other}>
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(beadcrumbList)}
          </script>
          {title && <title>{title}</title>}
        </Helmet>
        {!hidden && (
          <div>
            <Text
              type="legals"
              className="cursor-pointer hover:text-secondary-light"
              onClick={() => {
                window.location.assign(BASE_URL);
              }}
              color={white ? 'white' : 'gray-dark'}
            >
              Inicio
            </Text>
            {breadcrumbs.map((bc, index) => {
              const last = index === breadcrumbs.length - 1;

              return [
                <Text
                  key={randomizer.getString()}
                  type="legals"
                  color={white ? 'white' : 'gray-dark'}
                >
                  {' > '}
                </Text>,
                <Text
                  type="legals"
                  className={
                    !last ? 'cursor-pointer hover:text-secondary-light' : null
                  }
                  onClick={this.getOnClick(bc, last)}
                  color={white ? 'white' : 'gray-dark'}
                  key={randomizer.getString()}
                >
                  {bc.name}
                </Text>,
              ];
            })}
          </div>
        )}
      </div>
    );
  }
}

/**
 * Properties not documented here are applied to the root div.
 */
SEO.propTypes = {
  /**
   * List of items containing url, name, optional image and optional custom click function.
   */
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  /**
   * Optional dynamic title.
   */
  title: PropTypes.string,
  /**
   * If true, it will include breadcrumbs script but exclude it from the interface.
   * Avoid using it as possible, since Google recommends:
   * If the JSON-LD markup describes a performer, the HTML body should describe that same performer.
   */
  hidden: PropTypes.bool,
  /**
   * If true, text will be white. Useful for dark backgrounds.
   */
  white: PropTypes.bool,
};

SEO.defaultProps = {
  title: null,
  hidden: false,
  white: false,
};

export default SEO;
